import {
  ConstructorItemProps,
  ConstructorLayoutItem,
  ConstructorStyleItem,
  SlideConstructor,
} from '@/components/Organisms/DIT/types'

export const extractLayoutStyles = (
  curItems: SlideConstructor[]
): ConstructorItemProps[] => {
  const res: ConstructorItemProps[] = []
  curItems.forEach((item) => {
    if (item.type === 'text') {
      res.push({
        id: item.id,
        i: item.i,
        index: item.index,
        type: item.type,
        color: item.color,
        textAlign: item.textAlign,
        fontWeight: item.fontWeight,
        fontSize: item.fontSize,
        fontStyle: item.fontStyle,
        textDecoration: item.textDecoration,
        text: item.text,
        name: item.name,
        parameters: item.parameters,
      })
    }
    if (item.type === 'image') {
      res.push({
        id: item.id,
        i: item.i,
        index: item.index,
        type: item.type,
        imageUrl: item.imageUrl,
        // TODO generate Id
        imageId: 'sgfa',
        name: item.name,
      })
    }
  })
  return res
}

export const extractLayoutItems = (
  curItems: SlideConstructor[],
  activeItem: number,
  maxW: number,
  maxH: number,
  isDisabled: boolean
): ConstructorLayoutItem[] => {
  const res: ConstructorLayoutItem[] = []
  curItems.forEach((item) => {
    res.push({
      i: String(item.id),
      w: item.width || 1,
      h: item.height || 1,
      minH: 20,
      minW: 20,
      maxH: maxH,
      maxW: maxW,
      x: item.x,
      y: item.y,
      // static: true,
      isBounded: true,
      isDraggable: activeItem === item.id && !isDisabled,
      isResizable: activeItem === item.id && !isDisabled,
    })
  })
  return res
}

export const combineItems = (
  layoutItem: ConstructorItemProps,
  constructorItems: SlideConstructor[]
): SlideConstructor[] => {
  return constructorItems.map((item) => {
    if (item.id === layoutItem.id) {
      item = { ...item, ...layoutItem }
    }
    return item
  })
}

export const combineLayout = (
  layoutItems: ConstructorLayoutItem[],
  constructorItems: SlideConstructor[]
): SlideConstructor[] => {
  return constructorItems.map((item) => {
    const curLayoutItem = layoutItems.find(
      (layoutItem) => layoutItem.i === String(item.id)
    )
    if (String(item.id) === curLayoutItem?.i) {
      item = {
        ...item,
        ...curLayoutItem,
        width: curLayoutItem.w,
        height: curLayoutItem.h,
      }
    }
    return item
  })
}
